import {
  ADD_MICROLOAN_SETTINGS_ERROR,
  ADD_MICROLOAN_SETTINGS_START,
  ADD_MICROLOAN_SETTINGS_SUCCESS,
} from 'constants/action-types/settings/addMicroloanSettings';
import apiAction from 'helpers/apiAction';
import notification from 'helpers/notificationHelper';

export default data => (dispatch, push) => {
  dispatch(
    apiAction({
      url: '/groups/microloans/settings',
      method: 'POST',
      data,
      API_REQUEST_START: ADD_MICROLOAN_SETTINGS_START,
      API_REQUEST_FAILURE: ADD_MICROLOAN_SETTINGS_ERROR,
      API_REQUEST_SUCCESS: ADD_MICROLOAN_SETTINGS_SUCCESS,
      callbackOnSuccess: ({ message }) => {
        push('/settings/microloans');
        notification({ message });
      },
      callbackOnFailure: ({ message }) => {
        notification({ message, status: 'error' });
      },
      onEnd: () => false,
    }),
  );
};
